"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ExperimentContainer = _interopRequireDefault(require("./ExperimentContainer.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var render = function render(options) {
  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_ExperimentContainer["default"], _extends({
    atlasUrl: options.atlasUrl || "https://www.ebi.ac.uk/gxa/",
    pathToResources: options.pathToResources
  }, options.content)), typeof options.target === "string" ? document.getElementById(options.target) : options.target);
};

exports.render = render;